import { useState } from 'react';
import { PaginationOrderHow } from '../../../graphql/graphql';

export default function useInvoiceExportHistory(
	getInvoiceExportHistoryQuery: any,
) {
	const [page, setPage] = useState(1);
	const getInvoiceExportHistory = (filter: object) => {
		getInvoiceExportHistoryQuery({
			where: filter,
			pagination: {
				skip: (page - 1) * 20,
				order: {
					key: 'export_log.created_at',
					how: PaginationOrderHow.Desc,
				},
			},
		});
	};

	const getNextPage = () => {
		setPage(prev => prev + 1);
	};

	return { getInvoiceExportHistory, getNextPage, page, setPage };
}
